<template>
  <p>{{ $t('message') }}</p>
</template>

<script>
export default {
}
</script>

